import { render, staticRenderFns } from "./CampCard.vue?vue&type=template&id=09152d04&scoped=true&"
import script from "./CampCard.vue?vue&type=script&lang=js&"
export * from "./CampCard.vue?vue&type=script&lang=js&"
import style0 from "./CampCard.vue?vue&type=style&index=0&id=09152d04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09152d04",
  null
  
)

export default component.exports